// src/twitch/domain/services/twitchService.ts

export const $TWITCH_INTERVAL_REFRESH = 60 * 1000 * 5;
